import type { NextPage } from 'next'
import styles from './entryType.module.scss'
import OptionsButton from 'componentsUnits/optionsButton'
import { OptionElement, OptionsList } from 'componentsUnits/optionsList'
import React, { useEffect } from 'react';
import useLockScroll from 'components/useLockScroll';

interface Props {
  onClick: () => void
  onClose: () => void
  onOptionClick: () => void
  options: OptionElement[]
  title: string
  optionsVisible: boolean
}
const EntryTypeComponent: NextPage<Props> = (props: Props) => {
  const lockScroll = useLockScroll();

  useEffect(() => {
    lockScroll(props.optionsVisible)
  }, [props.optionsVisible]);


  return (
    <div className={`${styles.typeContainer} ${props.optionsVisible ? styles.typeContainerFront : null}`}>
      <div className={`${styles.type} ${styles.typePushLeft}`}>{props.title}</div>
      {props.optionsVisible && <div onClick={props.onClose} className={styles.typeContainer__fullscreenBackground}></div>}

      {props.options.length > 0 && <>
        <OptionsButton onClick={props.onClick} />
        <OptionsList options={props.options} onOptionClick={props.onOptionClick} visible={props.optionsVisible} onClose={props.onClose} />
      </>}
    </div>
  )
}

export default EntryTypeComponent
